
// src/web/components/group-form-panel.jsx

import React from 'react'
import connect from '../../connects/division-export-panel'
import {
  Card,
  CardText,
  CardTitle,
  CardActions
} from 'react-toolbox/lib/card'
import Checkbox from 'react-toolbox/lib/checkbox'
import {
  Button
} from 'react-toolbox/lib/button'
import DropDown from 'react-toolbox/lib/dropdown'
import {
   linkUI
} from '../../helpers/form-validator'
import moment from 'moment'
import theme from './themes/flat-card.css'
import DatePicker from './date-picker.jsx'


class DivisionExportPanel extends React.Component {
  state = { exportAll: true, fields: [], exportAllGroups: true, groups: [], exportGroupFields: [] }
  toggleExportAll = ()=> this.setState({ exportAll:  !this.state.exportAll })
  toggleExportGroupFields = (groupId)=> {
    if (!this.state.exportGroupFields.includes(groupId)) {
      this.setState({exportGroupFields: this.state.exportGroupFields.concat(groupId)})
    } else {
      const fieldListChecks = this.props.field_list.filter(item => item.group_id === groupId).map(item => item.fields).flat()
          .filter((item, index, self) => index === self.findIndex(i => i.group_id === item.group_id && i.name === item.name))
      let listFieldChecked = [];
      fieldListChecks && fieldListChecks.forEach((field) => {
          if (!this.state.fields.includes(field)) {listFieldChecked.push(field)}
      })
      this.setState({
        exportGroupFields: this.state.exportGroupFields.filter(gId => gId !== groupId),
        fields: [...this.state.fields, ...listFieldChecked]
      })
    }
  }
  toggleField = (field)=> {
    if (this.state.fields.includes(field))
      this.setState({ fields: _.filter(this.state.fields, (_field)=> _field != field) })
    else
      this.setState({ fields: this.state.fields.concat(field) })
  }
  toggleExportAllGroups = ()=> this.setState({ exportAllGroups:  !this.state.exportAllGroups })
  toggleGroup = (group)=> {
    if (this.state.groups.includes(group))
      this.setState({ groups: _.filter(this.state.groups, (_group)=> _group != group) })
    else
      this.setState({ groups: this.state.groups.concat(group) })
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.field_list != nextProps.field_list)
      this.setState({ fields: nextProps.field_list.map(i => i.fields).flat()
            .filter((item, index, self) => index === self.findIndex(i => i.group_id === item.group_id && i.name === item.name)
        ) })
    if (this.props.division)
      this.setState({ groups: nextProps.allGroups.filter(group => nextProps.division.groups.map(g => g.id).includes(group.group_id)).map(g=>g.group_id) })
  }

  render() {
    const {
      t,
      ui,
      updateUI,
      groupExportUrl,
      field_list,
      division,
      allGroups
    } = this.props
    const groups = allGroups.filter(group => division.groups.map(g => g.id).includes(group.group_id))

    return (
      <Card theme={theme}>
        <CardText>
          <strong>{t('label:開始日')}</strong>
          <DatePicker label={t('label:開始日')}
              value={ui.startDate.toDate()}
              maxDate={ui.endDate.toDate()}
              onChange={(date)=> updateUI({ startDate: moment(date) })} />
        </CardText>

        <CardText>
          <strong>{t('label:終了日')}</strong>
          <DatePicker label={t('label:終了日')}
              value={ui.endDate.toDate()}
              minDate={ui.startDate.toDate()}
              onChange={(date)=> updateUI({ endDate: moment(date) })} />
        </CardText>

        <CardActions>
          <Button raised primary
            type="submit"
            href={groupExportUrl(ui.startDate, ui.endDate,
              this.state.exportAll ? undefined : this.state.fields,
              this.state.exportAllGroups ? undefined : this.state.groups)
            }
            target='_blank'
            rel="noopener noreferrer"
            style={{ width: '100%' }}
            label={t('label:Excelダウンロード')} />
        </CardActions>

        {groups && groups.length > 0 &&
        <CardActions>
          <div>
          <Checkbox checked={this.state.exportAllGroups}
            label={t('label:export_all_groups')}
            onChange={this.toggleExportAllGroups} />
          <ul>
          {!this.state.exportAllGroups && _.map(groups, (group, i)=>
            <li key={i}>
              <Checkbox checked={this.state.groups.includes(group.group_id)}
                label={group.name} onChange={()=> this.toggleGroup(group.group_id)} />
            </li>
          )}
          </ul>
          </div>
        </CardActions>}

        <CardActions>
          <div>
          <Checkbox checked={this.state.exportAll}
                    label={t('label:すべて抽出')}
                    onChange={this.toggleExportAll} />
          {!this.state.exportAll && groups && groups.map((group, index) => (
              <div key={index}>
                <ul>
                <li>
                  <Checkbox
                            key={group.group_id}
                            checked={!this.state.exportGroupFields.includes(group.group_id)}
                            label={group.name}
                            onChange={() => this.toggleExportGroupFields(group.group_id)} />
                </li>
                {this.state.exportGroupFields.includes(group.group_id) &&
                  <ul>
                    {field_list && field_list
                        .filter(item => item.group_id === group.group_id).map(item => item.fields).flat()
                        .filter((item, index, self) => index === self.findIndex(i => i.group_id === item.group_id && i.name === item.name))
                        .map((field, i) => (
                            <li key={i}>
                              <Checkbox
                                  checked={this.state.fields.includes(field)}
                                  label={field.name}
                                  onChange={() => this.toggleField(field)}
                              />
                            </li>
                        ))}
                  </ul>
                }
                </ul>
              </div>
          ))}
          </div>
        </CardActions>
      </Card>
    )
  }
}

export const RawDivisionExportPanel = DivisionExportPanel
export default connect(DivisionExportPanel)



// WEBPACK FOOTER //
// ./src/web/components/division-export-panel.jsx